var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 412,
    height: 118,
    viewBox: "0 0 412 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 53,
    r: 7,
    stroke: "#FFF573"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF5794",
    points: "95.768 75.788 97.278 92.868 86.278 88.248"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#62F8D2",
    points: "358.925 46.699 371.545 53.767 356.437 65.815"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    x2: 356.5,
    y1: 80.5,
    y2: 80.5,
    stroke: "#6E358E",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    x2: 356.5,
    y1: 80.5,
    y2: 80.5,
    stroke: "#6E358E",
    strokeLinecap: "square",
    transform: "rotate(90 348 80.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderShapes);
export default __webpack_public_path__ + "static/media/header_shapes.42c74df66c0647f3d0d13c0b4abd3805.svg";
export { ForwardRef as ReactComponent };